import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

const opts = {
  breakpoint: {
    thresholds: {
      xs: 740,
    },
  },
};

export default new Vuetify(opts);
